import React, { useState, useEffect } from 'react';
import Welcomjf from '../images/welcometojf.png';
//import { Link } from 'react-router-dom';
import Water from '../images/water_navy_lvs.png';

function HomeNews() {
    const urlImg = "https://dev.jftheskinspecialist.com/images/news/";

    const [welcomeList, SetWelcomeList] = useState([]);

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/welcome')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetWelcomeList(datas.data);
            });
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto relative" style={{ backgroundColor: '#fffaee' }}>
            <div className='max-w-[1024px] mx-auto'>
                <div class="grid sm:grid-cols-2 sm:items-center gap-0">
                    <div class="sm:order-2">
                        <div class="relative pt-[50%] sm:pt-[100%]">
                            {welcomeList.map((image, index) => (
                                <div key={index}>
                                    <img src={urlImg + '' + image.featured_image} alt="" class="size-full absolute top-0 start-0 object-cover"  />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div class="sm:order-1">
                        <div style={{ padding: 10 }}>
                            <img src={Welcomjf} alt="" />
                        </div>
           
                        {welcomeList.map((descript, indexdesc) => (
                            <div class="mt-10 sm:mt-10 flex items-center" key={indexdesc}>
                                <div class="ms-3 sm:ms-4">
                                    <p class="text-xl text-justify" style={{ color: '#fd9400', fontFamily: 'MuseoSansRounded700', fontWeight: 'bold' }}>
                                        {getLang === 'id' ?
                                            <div dangerouslySetInnerHTML={{ __html: descript.content }}></div>
                                            :
                                            <div dangerouslySetInnerHTML={{ __html: descript.content_en }}></div>
                                        }
                                    </p>
                                </div>
                            </div>
                        ))}

                        {/*<section class="py-1 text-left">
                            <button class="mt-1 px-6 py-2"><Link to="/allproduct"><img src={Readmode} style={{ width: 150 }} alt="" /></Link></button>
                        </section>*/}
                    </div>
                </div>
            </div>
            <div class="w-full top-[400px] absolute hidden lg:block">
                <img src={Water} style={{ width: '100%' }} alt="" />
            </div>
            {/*<div class="mx-auto bg-[#feec87] w-full p-4 relative h-[50px] hidden lg:block">
                
            </div>*/}
        </div>
    );
}

export default HomeNews;
